import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './components/footer/Footer';
import Navbar from './components/header/Navbar';
import Maincomp from './components/home/Maincomp';
import Newnav from './components/newnav/Newnav';
import Login from './components/login_register/Login';
import Register from './components/login_register/Register';
import Cart from './components/cart/Cart';
import Buynow from './components/buynow/Buynow';
import Slide from './components/home/Slide';
import { CardProvider } from './components/contextreducer/ContextReducer';
import Checkout from './components/buynow/Checkout';
import Order from './components/buynow/Order';
import ConfirmOrder from './components/buynow/ConfirmOrder';

function App() {

  return (
    <CardProvider>
      <Router>
        <>
          <Navbar />
          <Newnav />
          <Routes>
            <Route exact path="/" element={<Maincomp />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/getcartitem/:postId" element={<Cart />} />
            <Route exact path="/buynow" element={<Buynow />} />
            <Route exact path="/slide" element={<Slide />} />
            <Route exact path="/checkout" element={<Checkout/>} />
            <Route exact path="/order" element={<Order />} />
            <Route exact path="/confirm-order" element={<ConfirmOrder />} />
          </Routes>
          <Footer />
        </>
      </Router>
    </CardProvider>
  );
}

export default App;
